import React, { createContext, useContext, useState } from 'react';

const SubscriptionContext = createContext();

export const useSubscription = () => {
    return useContext(SubscriptionContext);
};

export const SubscriptionProvider = ({ children }) => {
    const [selectedPackage, setSelectedPackage] = useState(() => {
        const savedPackage = localStorage.getItem('selectedPackage');
        return savedPackage ? JSON.parse(savedPackage) : null;
    });

    const selectPackage = (pkg) => {
        setSelectedPackage(pkg);
        localStorage.setItem('selectedPackage', JSON.stringify(pkg));
    };

    const clearPackage = () => {
        setSelectedPackage(null);
        localStorage.removeItem('selectedPackage');
    };

    return (
        <SubscriptionContext.Provider value={{ selectedPackage, selectPackage, clearPackage }}>
            {children}
        </SubscriptionContext.Provider>
    );
}; 